import type { InteractivityActionSnapshotOut } from '../InteractivityAction';
import { getInteractivityActionSnapshotMetadata } from '../interactivityActionSnapshotMetadata';

export type WalkInteractivityActionTreeFn = (
  interactivityAction: InteractivityActionSnapshotOut,
) => void;

export function walkInteractivityActionTree(
  interactivityAction: InteractivityActionSnapshotOut | undefined,
  walk: WalkInteractivityActionTreeFn,
): void {
  if (!interactivityAction) {
    return;
  }

  walk(interactivityAction);

  const metadata = getInteractivityActionSnapshotMetadata(interactivityAction.type);
  const innerInteractivityActions =
    metadata.innerInteractivityActions?.fromSnapshot?.(interactivityAction);

  innerInteractivityActions?.forEach(innerInteractivityAction => {
    walkInteractivityActionTree(innerInteractivityAction, walk);
  });
}
